<template>
    <div class="my_page">
        <!--SP用ヘッダー-->
        <div class="sp">
            <div class="menu">
                <div class="logo">
                    <router-link to="/"><img src="../assets/images/logo.svg" alt="logo" style="width:100%"></router-link>
                </div>
                <div class="sukikamo_list_sp">
                    <router-link to="/mypage"><img src="../assets/images/list_msg_sp.svg" alt="すきカモリスト"></router-link>
                    <div class="buttons">
                        <LoginButton/>
                    </div>
                </div>
            </div>
        </div>

        <!--PC用ホームボタン,戻るボタン-->
        <HomeBackButton/>
        <div class="pc">
            <!--マイホームリンクボタン-->
            <div class="myhome_btn" :class="{hidden: sukikamo_btn_is_hidden}">
                <!--<img v-if="hoverFlag" class="myhome_fukidashi" src="../assets/images/link_myhome_fukidashi.svg" alt="すきカモ吹き出し">-->
                <router-link to="/mypage/planboard" class="myhome_sukikamo pc" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction"><img src="../assets/images/link_myhome_btn.svg" alt="マイホームできたカモ"></router-link>
            </div>
        </div>
        <!--戻るボタン-->


        <div class="my_page_main">
            <!--タイトル-->
            <h2><img src="../assets/images/sukikamolist_tittle.svg" alt="すきカモリスト"></h2>
            <!--すきカモリスト表示-->
            <div class="sukikamo_list" v-if="all_sukikamo_list">
                <div class="sukikamo_items">
                    <router-link to="/mypage/list/">
                        <div class="all_sukikamo">
                            <img v-if="head_sukikamo_list.items[0].image_name" :src="`${root_path}room_image/${head_sukikamo_list.items[0].image_name}.jpg`" alt="room_image">
                            <img v-else :src="head_sukikamo_list.items[0].url" alt="room_image">
                            <img class="all_sukikamo_back" src="../assets/images/all_sukikamo_background.svg" alt="すべてのすきカモ背景">
                        </div>
                        <div class="caption">すべてのすきカモ</div>
                    </router-link>
                </div>
                <div v-for="list in all_sukikamo_list" :key="list.id" class="sukikamo_items">
                    <router-link :to="`/mypage/list/${list.id}`" v-if="list.items">
                        <div>
                            <img v-if="list.items[0].image_name" :src="`${root_path}room_image/${list.items[0].image_name}.jpg`" alt="room_image">
                            <img v-else :src="list.items[0].url" alt="room_image">
                        </div>
                        <div class="caption">
                            <span class="name">{{list.name}}</span>
                            <div class="menu_button">
                                <SukikamoListMenu :list_info="list"/>
                            </div>
                        </div>
                    </router-link>
                    <div v-else>
                        <div>
                            <div class="image_dummy">画像がありません</div>
                        </div>
                        <div class="caption">
                            <span>{{list.name}}</span>
                            <div class="menu_button">
                                <SukikamoListMenu :list_info="list"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="list_is_empty">
                <div>「すきカモ」に登録している画像がありません。</div>
            </div>
        </div>

        <!--SP用フッター-->
        <div class="sp">
            <div class="myhome_btnBox">
                <div class="footer_box" :class="{hidden: sukikamo_btn_is_hidden}">
                    <div class="myhome_btn_sp"><router-link to="/mypage/planboard"><img src="../assets/images/myhome_btn_sp.svg" alt="マイホームできたカモ"></router-link></div>
                    <div id="kamo_fukidashi"><img src="../assets/images/sukikamo_list_fukidashi_sp.svg" alt="吹き出し"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import AppPath from '../assets/js/AppPath'
    import Util from '../assets/js/Util'
    import LoginButton from '../components/LoginButton'
    import SukikamoListMenu from '../components/SukikamoListMenu'
    import HomeBackButton from '../components/HomeBackButton'

    export default {
        name: "MyPage",
        components: { LoginButton, SukikamoListMenu, HomeBackButton },
        data: () => ({
            root_path: AppPath.root,
            logged_in: false,
            hoverFlag: false, //ホバー処理
            sukikamo_btn_is_hidden: false,
            callback: () => {}
        }),
        computed: {
            ...mapState(["user_data", "is_sp"]),
            ...mapState(["sukikamo_list"]),
            ...mapState('my_page', { sukikamo_list_detail: "sukikamo_list" }),
            head_sukikamo_list: _this => {
                if ( !_this.all_sukikamo_list ) return [];
                const list_keys = Object.keys(_this.all_sukikamo_list);
                if ( !list_keys.length ) return [];

                const key = list_keys[0];
                return _this.all_sukikamo_list[key];
            },
            all_sukikamo_list: _this => {
                if ( !(_this.sukikamo_list && _this.sukikamo_list_detail) ) return null;
                const tmp = _this.sukikamo_list.reduce( (obj, item) => {
                    obj[item.id + ''] = item;
                    return obj;
                }, {});
                const list = {...tmp, ..._this.sukikamo_list_detail};
                return Object.keys(list).length ? list : null;
            }
        },
        async created() {
            if ( !this.user_data ) return;
            this.logged_in = true;

            await this.reloadSukikamoList();
        },
        methods: {
            ...mapActions('my_page', ["reloadSukikamoList"]),
            // ホバー処理
            mouseOverAction(){
                this.hoverFlag = true
            },
            mouseLeaveAction(){
                this.hoverFlag = false
            },
        },

        mounted(){
            // 指を離したら
            var kamo_fukidashi = document.querySelector("#kamo_fukidashi");
            window.addEventListener("touchend", function (event) {
                var fn = function() {
                    // console.log("指離し");
                    kamo_fukidashi.style.display = "block" ;
                };
                var tm = 4000;
                setTimeout(fn,tm);
            });
            //タッチしたら
            window.addEventListener("touchstart", function (event) {
                // console.log("タッチ中");
                kamo_fukidashi.style.display = "none" ;
            });

            const app = document.getElementById('app');
            const help_btn_pc = this.$el.querySelector('.pc .myhome_sukikamo');
            const help_btn_sp = this.$el.querySelector('.sp .myhome_btn_sp');
            this.callback = () => this.sukikamo_btn_is_hidden = !Util.detectCollision(app, this.is_sp ? help_btn_sp : help_btn_pc);
            window.addEventListener('scroll', this.callback);
        },
        destroyed() {
            window.removeEventListener('scroll', this.callback);
        },

    };
</script>

<style scoped lang="scss">
    .my_page {
        padding-bottom: 300px;
        .my_page_main {
            position: relative;
            max-width: 950px;
            margin: 0 auto;
            /*タイトル*/
            h2 {
                text-align: center;
                margin: 60px auto 110px;

                img {
                    padding: 60px 0 0;
                }
            }

            .list_is_empty {
                padding: 7rem 0.5rem;
                text-align: center;
            }

            /*すきカモリスト一覧*/
            .sukikamo_list {
                display: flex;
                flex-wrap: wrap;
                margin-left: 30px;

                .sukikamo_items {
                    margin-right: 30px;
                    margin-bottom: 60px;
                }

                > * {
                    /*width: 25%;*/
                    img, .image_dummy {
                        width: 200px;
                        height: 200px;
                        object-fit: cover;
                        border-radius: 5px;
                    }

                    .image_dummy {
                        background-color: lightgray;
                        display: flex;
                        color: white;
                        justify-content: center;
                        align-items: center;
                    }

                    .caption {
                        color: #816e66;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .name {
                            display: inline-block;
                            max-width: 175px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }

                    /*すべてのすきカモの重なり部分*/
                    .all_sukikamo {
                        position: relative;

                        .all_sukikamo_back {
                            width: 215px;
                            height: 215px;
                            position: absolute;
                            top: -15px;
                            left: 0;
                            z-index: -5;
                            max-width: none!important;
                        }
                    }
                }
            }
        }
    }
    /*ホームボタン、戻るボタン*/
    .homebtn {
        top: 100px;
    }
    .back_btn {
        top: 150px;
    }
    .homebtn,
    .back_btn {
        position: fixed;
        left: 13%;
        @media screen and (max-width:1800px) {
            left: 10%;
        }
        @media screen and (max-width:1700px) {
            left: 7%;
        }
        @media screen and (max-width:1600px) {
            left: 4%;
        }
        z-index: 50;
    }
    /*マイホームできたカモボタン*/
    .myhome_btn {
        position: relative;
        transition: 0.3s ease;
        &.hidden{
            opacity: 0;
            visibility: hidden;
        }
        .myhome_sukikamo {
            position: fixed;
            bottom: 50px;
            z-index: 50;
            right: 13%;
            @media screen and (max-width:1800px) {
                right: 10%;
            }
            @media screen and (max-width:1700px) {
                right: 7%;
            }
            @media screen and (max-width:1600px) {
                right: 4%;
            }
        }
        /*.myhome_fukidashi {*/
        /*    position: absolute;*/
        /*    right: 155px;*/
        /*    top: 480px;*/
        /*}*/
    }

    @media screen and (max-width:639px) {
        /*ページ全体*/
        .my_page {
            width: 100%;
            padding: 2px 0 200px;
            box-sizing: border-box;
            box-shadow: initial;
            /*SP用ヘッダー*/
            .menu {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                position: fixed;
                background: white;
                margin-top: -2px;
                padding: 2px 10px 0;
                z-index: 20;
                box-sizing: border-box;
                .logo {
                    width: 95px;
                }
                /*すきカモリストボタン*/
                .sukikamo_list_sp {
                    display: flex;
                    img {
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                /*ログインボタン*/
                .buttons {
                    position: relative;
                    display: flex;
                }
            }
        }
        /*SP用フッター*/
        .myhome_btnBox {
            position: relative;
            .footer_box {
                display: flex;
                width: 100%;
                height: 65px;
                padding: 10px 10px 10px 0;
                box-sizing: border-box;
                position: fixed;
                bottom: 0;
                z-index: 10;
                transition: 0.3s ease;
                &.hidden{
                    opacity: 0;
                    visibility: hidden;
                }
                /*マイホームできたカモボタン*/
                .myhome_btn_sp {
                    margin: -39px 10px 0 auto;
                    img {
                        height: 84px;
                    }
                }
                #kamo_fukidashi {
                    display: none;
                    position: absolute;
                    top: -150px;
                    right: 45px;
                }
            }
        }

        /*すきカモリスト*/
        .my_page {
            .my_page_main {
                /*タイトル*/
                h2 {
                    margin: 76px auto 40px;
                    img {
                        padding: 16px 0 12px;
                    }
                }
                /*リスト一覧*/
                .sukikamo_list {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    width: 350px;
                    padding-left: 20px;
                    margin: 0 auto;
                    .sukikamo_items{
                        margin-right: 0;
                        margin-bottom: 0;
                    }
                    > * {
                        /*width: 25%;*/
                        img, .image_dummy {
                            width: 130px;
                            height: 130px;
                            object-fit: cover;
                            margin-top: 0;
                            margin-right: 20px;
                        }
                        .image_dummy {
                            font-size: 12px;
                        }
                        .caption{
                            font-size: 13px;
                            margin-right: 20px;
                            margin-bottom: 25px;
                            .name{
                                max-width: 100px;
                            }
                        }
                        /*すべてのすきカモの重なり部分*/
                        .all_sukikamo {
                            .all_sukikamo_back {
                                width: 140px;
                                height: 140px;
                                position: absolute;
                                top: -10px;
                                left: 1px;
                                z-index: -5;
                            }
                        }
                    }
                }
            }
        }

        .back_btn {
            width: 10px;
            top: 183px;
            left: 10px;
            z-index: 10;
        }
    }
</style>
